<template>
  <div class="w-[420px]">
    <div class="font-semibold text-[36px] text-font-1">
      {{ $t('chuang-jian-tuan-dui-ru-men-ban') }}
    </div>
    <div class="text-font-80 mt-[12px] mb-[36px]">
      {{ $t('she-zhi-tuan-dui-zhang-hao-xin-xi') }}
    </div>
    <a-form
      :model="formState"
      layout="vertical"
      :hide-required-mark="true"
      @finish="onFinish"
      @finishFailed="onFinishFailed"
    >
      <a-form-item
        name="organization_name"
        :rules="[{ required: true, message: $t('qing-shu-ru-tuan-dui-ming-cheng') }]"
      >
        <a-input
          v-model:value="formState.organization_name"
          class="yy-input-xlg"
          show-count
          :maxlength="isChinese() ? 24 : 50"
          :placeholder="$t('qing-shu-ru-tuan-dui-ming-cheng')"
        />
      </a-form-item>
      <a-form-item
        name="nick_name"
        :rules="[{ required: true, message: $t('qing-shu-ru-ge-ren-ni-cheng') }]"
      >
        <a-input
          v-model:value="formState.nick_name"
          class="yy-input-xlg"
          show-count
          :maxlength="isChinese() ? 24 : 50"
          :placeholder="$t('qing-shu-ru-ge-ren-ni-cheng')"
        />
      </a-form-item>
      <a-form-item
        v-if="!isGlobalVersion()"
        name="email"
        :rules="[
          { required: true, message: $t('qing-shu-ru-you-xiang') },
          {
            pattern: emailReg,
            message: $t('qing-shu-ru-zheng-que-de-you-xiang'),
          },
        ]"
      >
        <a-input
          v-model:value="formState.email"
          class="yy-input-xlg"
          :placeholder="$t('qing-shu-ru-you-xiang')"
        />
      </a-form-item>
      <a-form-item
        name="num_of_users"
        :label="$t('1-tuan-dui-nei-yu-ji-shi-yong-ren-shu')"
        class="form-item-label"
        :rules="[
          {
            required: true,
            message: $t('qing-xuan-ze-tuan-dui-nei-yu-ji-shi-yong-ren-shu'),
          },
        ]"
      >
        <a-radio-group v-model:value="formState.num_of_users" :options="quantityOptions()">
        </a-radio-group>
      </a-form-item>
      <a-form-item
        name="company_industry"
        :label="$t('2-qing-xuan-ze-nin-de-gong-zuo-hang-ye')"
        class="form-item-label"
        :rules="[
          {
            required: true,
            message: $t('qing-shu-ru-nin-de-gong-zuo-hang-ye'),
          },
        ]"
      >
        <a-radio-group v-model:value="formState.company_industry">
          <a-radio v-for="item in industryOption?.children" :key="item.tag_id" :value="item.tag_id">
            {{ item?.tag_name }}
          </a-radio>
          <a-radio :value="VALUE_OTHER">
            {{ $t('qi-ta') }}
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        v-if="formState.company_industry === VALUE_OTHER"
        name="other_industry"
        :rules="[{ required: true, message: $t('qing-shu-ru-hang-ye-ming-cheng') }]"
      >
        <a-input
          v-model:value="formState.other_industry"
          :maxlength="isChinese() ? 24 : 50"
          show-count
          :placeholder="$t('qing-shu-ru-hang-ye-ming-cheng')"
          class="yy-input-xlg"
        />
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          :disabled="!canSubmit"
          html-type="submit"
          :loading="loading"
          class="yy-btn-xlg btn-shadow w-full"
        >
          {{ $t('li-ji-chuang-jian') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script lang="ts" setup>
import { createStarterOrg } from '~/api';
import { TagKey } from '~/constants/index';
import { quantityOptions } from '~/constants/teamCreate';
import { isChinese, isGlobalVersion } from '~/utils/area';
import { emailReg } from '~/utils/regExp';

const emit = defineEmits(['next', 'account']);
const loading = ref(false);

const VALUE_OTHER = 1000;

const centerTags = useCenterTags();

const formState = reactive({
  organization_name: '',
  nick_name: '',
  email: '',
  num_of_users: '',
  company_industry: undefined,
  other_industry: '',
});

const canSubmit = computed(() => {
  return (
    formState.organization_name &&
    formState.nick_name &&
    (isGlobalVersion() ? true : formState.email) &&
    formState.num_of_users &&
    (formState.company_industry || formState.other_industry)
  );
});
const { $t } = useNuxtApp();

const industryOption = computed(() =>
  centerTags.value.tags.find(item => item.outer_id === TagKey?.INDUSTRY),
);

async function onFinish() {
  loading.value = true;
  const val = toRaw(formState);
  val.company_industry = val.company_industry === VALUE_OTHER ? undefined : val.company_industry;
  const { data } = await createStarterOrg(val);
  loading.value = false;

  emit('account', data);
  emit('next');
}

function onFinishFailed() {}
</script>
<style lang="scss" scoped>
.form-item-label {
  // 覆盖 form-item label
  :deep(.ant-form-item-label > label) {
    color: inherit;
  }

  :deep(.ant-radio-wrapper) {
    padding-bottom: 8px;
  }
}
</style>
